import _getIterator from 'babel-runtime/core-js/get-iterator';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import Identifier from '../Utils/Identifier';
import DLog from '../Utils/DLog';
import Question from '../Items/Question';
import Person from '../Items/Person';
import Slide from '../Items/Slide';

function parseJson(str, dlog, callback) {
    var json = void 0;

    try {
        json = JSON.parse(str);
    } catch (e) {
        if (dlog) {
            dlog.error('BroadcastManager parseJSON - Error when parsing: ' + str);
        }

        return;
    }

    if (callback && json !== undefined) {
        callback(json);
    }

    return json;
}

var BroadcastManager = function () {
    function BroadcastManager(baseUrl, presentation, token) {
        var _this = this;

        var logger = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new DLog();

        _classCallCheck(this, BroadcastManager);

        this.dlog = logger;
        this.webSocket = new WebSocket('wss://' + baseUrl + presentation.websocket + '?auth_code=' + token.replace('Bearer ', ''));
        this.webSocket.binaryType = 'arraybuffer';

        this.webSocket.onopen = function () {
            logger.debug('BroadcastManager constructor - Websocket opened for presentation: ' + presentation.id);
        };

        this.webSocket.onmessage = function (msg) {
            _this.webSocketEventHandler(msg);
        };

        this.webSocket.onclose = function () {
            logger.debug('BroadcastManager constructor - Websocket closed for presentation: ' + presentation.id);
        };

        this.webSocket.onerror = function (err) {
            logger.debug('BroadcastManager constructor - Websocket error for presentation: ' + presentation.id + ' - ' + _JSON$stringify(err));
        };
    }

    _createClass(BroadcastManager, [{
        key: 'destroy',
        value: function destroy() {
            if (this.websocket) {
                this.close();
            }

            this.listeners = undefined;
        }
    }, {
        key: 'addListener',
        value: function addListener(eventName, callback) {
            if (!eventName || !callback) {
                this.dlog.debug('BroadcastManager addEventListener - Invalid arguments');
                return;
            }

            if (!this.listeners) {
                this.listeners = {};
            }

            if (!this.listeners[eventName]) {
                this.listeners[eventName] = {};
            }

            var id = Identifier.guid();

            this.listeners[eventName][id] = callback;

            return {
                eventName: eventName,
                id: id
            };
        }
    }, {
        key: 'removeListener',
        value: function removeListener(eventObjectId) {
            if (!eventObjectId || !eventObjectId.id || !eventObjectId.eventName) {
                this.dlog.debug('BroadcastManager removeListener - Invalid arguments');
                return;
            }

            if (this.listeners && this.listeners[eventObjectId.eventName]) {
                delete this.listeners[eventObjectId.eventName];
            }
        }
    }, {
        key: 'triggerEvent',
        value: function triggerEvent(eventName, data) {
            var _this2 = this;

            if (eventName === undefined || !this.listeners || !this.listeners[eventName]) {
                return;
            }

            setTimeout(function () {
                var keys = _Object$keys(_this2.listeners[eventName]);

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = _getIterator(keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var key = _step.value;

                        _this2.listeners[eventName][key](data);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }, 0);
        }
    }, {
        key: 'webSocketEventHandler',
        value: function webSocketEventHandler(msg) {
            var _this3 = this;

            var len = msg.data.byteLength;
            var dataView = new DataView(msg.data);
            var webSocketHeader = dataView.getUint32(0);
            var jsonInfo = '';
            var WSV1_SLIDE_INFO_INDEX = 61;

            if (len > WSV1_SLIDE_INFO_INDEX) {
                var dstU8 = new Uint8Array(dataView.buffer, WSV1_SLIDE_INFO_INDEX, len - WSV1_SLIDE_INFO_INDEX);
                jsonInfo = new TextDecoder('utf-8').decode(dstU8);
            }

            if (len <= 0 || webSocketHeader !== 1) {
                return;
            }

            var frameType = dataView.getUint32(4); // frameType starts at byte 4

            switch (frameType) {
                case 2:
                    // FRAME_QUESTION_RECEIVED
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Question Received" - ' + jsonInfo);

                    parseJson(jsonInfo, this.dlog, function (json) {
                        _this3.triggerEvent('questionAdded', new Question(json));
                    });

                    break;

                case 3:
                    // FRAME_QUESTION_LIKED_RECEIVED
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Question liked" - ' + jsonInfo);

                    parseJson(jsonInfo, this.dlog, function (json) {
                        _this3.triggerEvent('questionLiked', new Question(json));
                    });

                    break;

                case 4:
                    // MESSAGE_ADD_PERSON
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Attendee added" - ' + jsonInfo);

                    parseJson(jsonInfo, this.dlog, function (json) {
                        _this3.triggerEvent('attendeeJoined', new Person(json));
                    });

                    break;

                case 5:
                    // MESSAGE_REMOVE_PERSON
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Attendee removed" - ' + jsonInfo);
                    this.triggerEvent('attendeeLeft', jsonInfo);
                    break;

                case 6:
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Slide changed" - ' + jsonInfo);

                    parseJson(jsonInfo, this.dlog, function (json) {
                        _this3.triggerEvent('slideChanged', new Slide(json));
                    });

                    break;

                case 7:
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Start survey" - ' + jsonInfo);

                    parseJson(jsonInfo, this.dlog, function (json) {
                        _this3.triggerEvent('surveyStarted', json);
                    });

                    break;

                case 11:
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Slides uploaded" - ' + jsonInfo);
                    this.triggerEvent('slidesUploaded', jsonInfo);
                    break;

                case 12:
                    // SlideUploaded
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Slide uploaded" - ' + jsonInfo);
                    this.triggerEvent('slideUploaded', jsonInfo);
                    break;

                case 13:
                    // UpdatedPresentation
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Presentation updated" - ' + jsonInfo);
                    this.triggerEvent('presentationUpdated', jsonInfo);
                    break;

                case 15:
                    // SlideDeleted
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Slide deleted" - ' + jsonInfo);
                    this.triggerEvent('slideDeleted', jsonInfo);
                    break;

                case 16:
                    // DeletedPresentation
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Presentation deleted" - ' + jsonInfo);
                    this.triggerEvent('presentationDeleted', jsonInfo);
                    break;

                case 17:
                    // StopSurveyMsg
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Survey stopped" - ' + jsonInfo);

                    parseJson(jsonInfo, this.dlog, function (json) {
                        _this3.triggerEvent('surveyStopped', json);
                    });

                    break;

                case 23:
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Question updated" - ' + jsonInfo);

                    parseJson(jsonInfo, this.dlog, function (json) {
                        _this3.triggerEvent('questionPropsUpdated', new Question(json));
                    });

                    break;

                case 1001:
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Message 1001" - ' + jsonInfo);
                    this.triggerEvent('1001', jsonInfo);
                    break;

                case 1002:
                    // Room or Group insights. this is a DataScience bot message
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Message 1002" - ' + jsonInfo);
                    this.triggerEvent('1002', jsonInfo);
                    break;

                case 1003:
                    // Individual insights. this is a DataScience bot message
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received event "Message 1003" - ' + jsonInfo);
                    this.triggerEvent('1003', jsonInfo);
                    break;

                default:
                    this.dlog.debug('BroadcastManager webSocketEventHandler - Received undefined event ' + jsonInfo);
                    break;
            }
        }
    }]);

    return BroadcastManager;
}();

export default BroadcastManager;


//////////////////
// WEBPACK FOOTER
// ./submodules/dialogloop-sdk-js/dist/WebSockets/BroadcastManager.js
// module id = 505
// module chunks = 0